var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Shield = function Shield(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.672 2.26A.994.994 0 0 0 12 2a.999.999 0 0 0-.672.26A11 11 0 0 1 3.546 5a1 1 0 0 0-1.005.717 13 13 0 0 0 9.208 16.25 1 1 0 0 0 .502 0 13.001 13.001 0 0 0 9.208-16.25 1 1 0 0 0-1.005-.717 11 11 0 0 1-7.782-2.742ZM12 4.296a13 13 0 0 1-7.728 2.714A11 11 0 0 0 12 19.964 11 11 0 0 0 19.728 7.01 13 13 0 0 1 12 4.297Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Shield;